import {useSelector} from "react-redux";
import {Navigate} from "react-router-dom";

export const AuthenticatedRoute = ({children}) => {
    const tokenInfo = useSelector(state => state.Token);
    if(tokenInfo.token){
        return children
    }

    return <Navigate to="/" />
}

export const AuthenticatedAdminRoute = ({children}) => {
    const tokenInfoAdmin = useSelector(state => state.AdminPortal);
    if(tokenInfoAdmin.token){
        return children
    }

    return <Navigate to="/admin/login" />
}

export const AuthenticatedLeaderRoute = ({children}) => {
    const tokenInfoLeader = useSelector(state => state.LeaderPortal);
    if(tokenInfoLeader.token){
        return children
    }

    return <Navigate to="/leader/login" />
}